"use strict";
const PIXELS_PER_LEVEL = 22 * window.devicePixelRatio;
const MUTE_THRESHOLD = 10 * window.devicePixelRatio;
const HIDE_THRESHOLD = 0.5 * window.devicePixelRatio;
const LABEL_THRESHOLD = 20 * window.devicePixelRatio;
const BAR_BORDER_WIDTH = 0.5 * window.devicePixelRatio;
const BAR_TEXT_PADDING_LEFT = 4 * window.devicePixelRatio;
const GROUP_STRIP_WIDTH = 3 * window.devicePixelRatio;
const GROUP_STRIP_PADDING = 3 * window.devicePixelRatio;
const GROUP_STRIP_MARGIN_LEFT = 4 * window.devicePixelRatio;
const GROUP_TEXT_OFFSET = 2 * window.devicePixelRatio;
const MIN_WIDTH_TO_SHOW_BOTH_TOPTABLE_AND_FLAMEGRAPH = 800;
const MIN_WIDTH_FOR_SPLIT_VIEW = 800;
const MIN_WIDTH_TO_SHOW_SPLIT_PANE_SELECTORS = 1100;
const TOP_TABLE_COLUMN_WIDTH = 120;
const FLAMEGRAPH_CONTAINER_HEIGHT = 800;

export { BAR_BORDER_WIDTH, BAR_TEXT_PADDING_LEFT, FLAMEGRAPH_CONTAINER_HEIGHT, GROUP_STRIP_MARGIN_LEFT, GROUP_STRIP_PADDING, GROUP_STRIP_WIDTH, GROUP_TEXT_OFFSET, HIDE_THRESHOLD, LABEL_THRESHOLD, MIN_WIDTH_FOR_SPLIT_VIEW, MIN_WIDTH_TO_SHOW_BOTH_TOPTABLE_AND_FLAMEGRAPH, MIN_WIDTH_TO_SHOW_SPLIT_PANE_SELECTORS, MUTE_THRESHOLD, PIXELS_PER_LEVEL, TOP_TABLE_COLUMN_WIDTH };
//# sourceMappingURL=constants.mjs.map
